import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-讲师管理",
  "use": "icon-讲师管理-usage",
  "viewBox": "0 0 160 160",
  "content": "<symbol viewBox=\"0 0 160 160\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-讲师管理\">\n<path d=\"M100.6 33.2C100.6 44.21 91.3465 53.4 79.6001 53.4C67.8537 53.4 58.6001 44.21 58.6001 33.2C58.6001 22.19 67.8537 13 79.6001 13C91.3465 13 100.6 22.19 100.6 33.2Z\" stroke-width=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M123.2 92.8C123.2 71.5923 103.859 54.4 80 54.4C56.1413 54.4 36.8 71.5923 36.8 92.8\" stroke-width=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M148.8 49.6L127.648 87.8435\" stroke-width=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M147 104C147 110.075 142.075 115 136 115L22 115C17.0294 115 13 110.971 13 106L13 96.2L147 96.2L147 104Z\" stroke-width=\"10\" />\n<path d=\"M126.2 136.8C126.2 142.875 121.275 147.8 115.2 147.8L42.8 147.8C37.8294 147.8 33.8 143.771 33.8 138.8L33.8 117.8L126.2 117.8L126.2 136.8Z\" stroke-width=\"10\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/讲师管理.svg
// module id = trGR
// module chunks = 26